/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AttendanceClockStatus } from '../../models/attendance-clock-status';
import { Rotation } from '../../models/rotation';
import { WingType } from '../../models/wing-type';

export interface ExportAttendanceAuditLogs$Params {
  date?: string;
  search?: string;
  wingType?: Array<WingType>;
  baseCode?: Array<string>;
  rotation?: Array<Rotation>;

/**
 * Shift IDs from `GET /api/scheduler/attendance-audit-logs/shifts`. A row matches a selected shift when its allocation Base for the date is that shift's Base and its assigned shift code is that shift's code. A row that matches any selected shift matches. Fixed Wing rows match none. Omitted or empty means no shift restriction. An ID that is not a non-deleted shift is a 400 (`errors.attendanceShiftInvalid`). A retired STANDBY assignment with no shift record is listed only when no shift filter is applied.
 */
  shift?: Array<number>;

/**
 * When true, Rotor Wing rows with no shift for the date also match, alone or together with `shift`. Fixed Wing rows never match.
 */
  unassignedShift?: boolean;
  clockInStatus?: Array<AttendanceClockStatus>;
  clockOutStatus?: Array<AttendanceClockStatus>;

/**
 * Time zone the exported clock-in and clock-out times are written in and the delay is calculated in. An IANA zone ID (for example Asia/Riyadh) or a UTC offset (for example +03:00). Missing, blank, or unknown is a 400.
 */
  timeZone: string;
  sort?: string;
}

export function exportAttendanceAuditLogs(http: HttpClient, rootUrl: string, params: ExportAttendanceAuditLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, exportAttendanceAuditLogs.PATH, 'get');
  if (params) {
    rb.query('date', params.date, {});
    rb.query('search', params.search, {});
    rb.query('wingType', params.wingType, {"style":"form","explode":true});
    rb.query('baseCode', params.baseCode, {"style":"form","explode":true});
    rb.query('rotation', params.rotation, {"style":"form","explode":true});
    rb.query('shift', params.shift, {"style":"form","explode":true});
    rb.query('unassignedShift', params.unassignedShift, {});
    rb.query('clockInStatus', params.clockInStatus, {"style":"form","explode":true});
    rb.query('clockOutStatus', params.clockOutStatus, {"style":"form","explode":true});
    rb.query('timeZone', params.timeZone, {});
    rb.query('sort', params.sort, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

exportAttendanceAuditLogs.PATH = '/api/scheduler/attendance-audit-logs/export';
